import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';
import axiosCWCharge from 'app/api/apiCwCharge';
import PaginationModel from 'app/utils/PaginationApiModel';

export const getCWChargesCommon = createAsyncThunk('commonAPI/cwCharges/getCWChargesCommon', async () => {
   const params = PaginationModel.PageSize9999ApiModel();
   const response = await axiosCWCharge.apiCWCharge.list({ ...params });
   const data = await response.data;

   return data === undefined ? null : data;
});

const cWChargeCommonDataAdapter = createEntityAdapter({
   selectId: (cWCharge) => cWCharge.iId,
});

export const { selectAll: selectCWChargeCommon } = cWChargeCommonDataAdapter.getSelectors((state) => state.commonAPI.cwCharges.dataCWCharges);

const cwChargesCommonSlice = createSlice({
   name: 'cwCharges',
   initialState: {
      dataCWCharges: cWChargeCommonDataAdapter.getInitialState(),
   },
   reducers: {
      setLoading: {
         reducer: (state, action) => {
            state.loading = action.payload;
         },
      },
   },
   extraReducers: {
      [getCWChargesCommon.fulfilled](state, { payload }) {
         cWChargeCommonDataAdapter.setAll(state.dataCWCharges, payload);
      },
   },
});

export const { setLoading } = cwChargesCommonSlice.actions;

export default cwChargesCommonSlice.reducer;
